/**
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export const Text: Record<string, Theme.ProgressRing.TextType> = {
  enum: 'enum',
  percent: 'percent',
  hidden: 'hidden',
} as const;

export default Text;
